var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7 0a6.99 6.99 0 0 1 7 7 7 7 0 1 1-7-7m.495 9h-.99A.497.497 0 0 0 6 9.505v.99c0 .279.214.505.505.505h.99A.497.497 0 0 0 8 10.495v-.99A.497.497 0 0 0 7.495 9m0-6h-.99A.496.496 0 0 0 6 3.498v4.004c0 .275.214.498.505.498h.99A.496.496 0 0 0 8 7.502V3.498A.494.494 0 0 0 7.495 3"
})));
export default SvgWarning;